import React, { useState,useEffect, useRef } from 'react';
import { Link, Route,Routes} from 'react-router-dom';
import BottomTab from './BottomTab';
import axios from 'axios';
import Api from "../Api/Api.json";
import { Capacitor } from "@capacitor/core";

// Conditionally import StethoPlugin only on native platforms
let StethoPlugin = null;
if (Capacitor.isNativePlatform()) {
  const StethoPluginModule = require("../StethoPlugin");
  StethoPlugin = StethoPluginModule.default;
}

const items = ['BP', 'Stetho', 'Glucose'];
var user_id='0';
var patient_id='0';

const Stetho = () => {
    const [newFlag,setNewFlag]=useState(false);
    const [mp3FileList,setMP3FileList]=useState([]);
    const [mp3URL,setMP3URL]=useState('');
    const [imageURL,setImageURL]=useState('');
    const [playing,setPlaying]=useState(false);
    const [currentTime,setCurrentTime]=useState(0);
    const [duration,setDuration]=useState(0);
    const [bpstatus,setBPStatus]=useState("Click connect device");
    const [selectedFileName, setSelectedFileName] = useState('');
    const [submitMessage, setSubmitMessage] = useState('');
    const [reportStr, setReportStr] = useState('');
    const audioRef = useRef(null);
    const handlersRef = useRef({});
    var external_id=0;

    useEffect(()=>{
      if (localStorage.getItem('user_info')!==null){
        //navigate('/Landing/tab1')
        var user_info=JSON.parse(localStorage.getItem('user_info'));
        external_id=user_info.phone;
        user_id=user_info.di_id.toString();
        patient_id=user_id;
        // Get patient_id from localStorage if available, otherwise use di_id
        // if (localStorage.getItem('patient_id')!==null){
        //   patient_id=JSON.parse(localStorage.getItem('patient_id'));
        // } else {
        //   patient_id=user_id;
        // }
        console.log("userid");
        console.log(user_id);
      }
    },[]);

    // Fetch MP3 file list when showing previous recordings
    useEffect(()=>{
      if (!newFlag && patient_id !== '0') {
        const headers = { headers: { "Content-Type": "application/json" } }
        const url = Api.PATIENT_API;
        const requestData = {
          task: 'getUSBStethoMP3List',
          patient_id: patient_id
        };

        axios.post(url,requestData,headers)
        .then(response=>{
          if (response.data.length > 0){
            // Extract only filenames from full paths
            const fileNames = response.data.map(fullPath => {
              // Extract filename from path (e.g., "teledocdata/patient_files/stethoAudioFiles/130/stetho_2025_12_08_23_47_58.mp3" -> "stetho_2025_12_08_23_47_58.mp3")
              const parts = fullPath.split('/');
              return parts[parts.length - 1];
            });
            setMP3FileList(fileNames);             
          }
        })
        .catch(error=>{
          console.log(error)
        });
      }
    },[newFlag, patient_id]);

    const previousBtn=()=>{
        setNewFlag(false);
    };
    const newRecordingBtn=()=>{
        setNewFlag(true);
    };

    useEffect(() => {
      // Only add listener on native platforms
      if (Capacitor.isNativePlatform() && StethoPlugin) {
        StethoPlugin.addListener('sembpmstatus', (info) => {
          setBPStatus(JSON.stringify(info));
          console.log('Received background task completion event: ', info);
        });
        
        // Listen for USB permission status
        const permissionListener = StethoPlugin.addListener('stethoPermissionStatus', (info) => {
          console.log('Received USB permission status: ', info);
          const status = info.status;
          const message = info.message || status;
          
          if (status === 'granted') {
            setBPStatus('USB permission granted - Device connected');
          } else if (status === 'denied') {
            setBPStatus('USB permission denied');
          } else if (status === 'not_asked') {
            setBPStatus('USB permission not asked');
          }
        });
        
        // Listen for recording status updates
        const recordingListener = StethoPlugin.addListener('stethoRecordingStatus', (info) => {
          console.log('Received recording status: ', info);
          const message = info.message || '';
          const status = info.status;
          
          if (status === 'completed') {
            setBPStatus('Recording completed.');
          } else if (message) {
            setBPStatus(message);
          }
        });
        
        // Listen for upload status updates
        const uploadListener = StethoPlugin.addListener('stethoUploadStatus', (info) => {
          console.log('Received upload status: ', info);
          const status = info.status;
          const message = info.message || '';
          
          if (status === 'success') {
            setBPStatus('File uploaded successfully');
          } else if (status === 'error') {
            setBPStatus('Upload failed, make sure you are connected to internet.');
          }
        });
        
        // Cleanup listeners on unmount
        return () => {
          permissionListener.remove();
          recordingListener.remove();
          uploadListener.remove();
        };
      }
    }, []);

    const handleClick = async (item) => {
      // Stop previous audio if playing (cleanup will happen in useEffect when mp3URL changes)
      if (audioRef.current) {
        audioRef.current.pause();
      }
      setPlaying(false);
      setCurrentTime(0);
      setDuration(0);
      setSelectedFileName(item);
      setSubmitMessage('');
      setReportStr('');
      
      //get image url
      //get mp3 url
      const headers = { headers: { "Content-Type": "application/json" } }
      const url = Api.PATIENT_API;
      var requestData = {
        task: 'getStethoDownloadURL',
        patient_id: patient_id,
        fileName:item
      };
      await axios.post(url,requestData,headers)
      .then(response=>{
        if (response.data.length > 0){
          setMP3URL(response.data);   
        }
      })
      .catch(error=>{
        console.log(error)
      });
      requestData = {
        task: 'getStethoWaveImg',
        patient_id: patient_id,
        fileName:item
      };
      await axios.post(url,requestData,headers)
      .then(response=>{
        if (response.data.length > 0){
          setImageURL(response.data);   
        }
      })
      .catch(error=>{
        console.log(error)
      });
      requestData = {
        task: 'getStethoReport',
        patient_id: patient_id,
        fileName:item
      };
      await axios.post(url,requestData,headers)
      .then(response=>{
        if (response.data) {
          setReportStr(response.data);
        }
      })
      .catch(error=>{
        console.log(error)
      });
      
    };

    const handleSubmitForReview = async () => {
      if (!selectedFileName || patient_id === '0') {
        setSubmitMessage('Please select a recording first.');
        return;
      }

      const headers = { headers: { "Content-Type": "application/json" } };
      const url = Api.PATIENT_API;
      const requestData = {
        task: 'submitStethoHeartReportRequest',
        patient_id: patient_id,
        fileName: selectedFileName
      };

      try {
        const response = await axios.post(url, requestData, headers);
        if (response.status === 200) {
          setSubmitMessage('request submitted');
        } else {
          setSubmitMessage('request not submitted. Something went wrong.');
        }
      } catch (error) {
        console.log(error);
        setSubmitMessage('request not submitted. Something went wrong.');
      }
    };

    // Initialize audio when mp3URL changes
    useEffect(() => {
      // Cleanup previous audio first
      if (audioRef.current && handlersRef.current) {
        audioRef.current.pause();
        if (handlersRef.current.handleLoadedMetadata) {
          audioRef.current.removeEventListener('loadedmetadata', handlersRef.current.handleLoadedMetadata);
        }
        if (handlersRef.current.handleTimeUpdate) {
          audioRef.current.removeEventListener('timeupdate', handlersRef.current.handleTimeUpdate);
        }
        if (handlersRef.current.handleEnded) {
          audioRef.current.removeEventListener('ended', handlersRef.current.handleEnded);
        }
        if (handlersRef.current.handleError) {
          audioRef.current.removeEventListener('error', handlersRef.current.handleError);
        }
        audioRef.current = null;
        handlersRef.current = {};
      }
      
      if (mp3URL) {
        audioRef.current = new Audio(mp3URL);
        
        // Define event handlers
        const handleLoadedMetadata = () => {
          if (audioRef.current) {
            setDuration(audioRef.current.duration);
          }
        };
        
        const handleTimeUpdate = () => {
          if (audioRef.current) {
            setCurrentTime(audioRef.current.currentTime);
          }
        };
        
        const handleEnded = () => {
          setPlaying(false);
          setCurrentTime(0);
        };
        
        const handleError = (e) => {
          console.error('Audio error:', e);
          setPlaying(false);
        };
        
        // Store handlers for cleanup
        handlersRef.current = {
          handleLoadedMetadata,
          handleTimeUpdate,
          handleEnded,
          handleError
        };
        
        // Set up event listeners
        audioRef.current.addEventListener('loadedmetadata', handleLoadedMetadata);
        audioRef.current.addEventListener('timeupdate', handleTimeUpdate);
        audioRef.current.addEventListener('ended', handleEnded);
        audioRef.current.addEventListener('error', handleError);
        
        // Cleanup function
        return () => {
          if (audioRef.current && handlersRef.current) {
            audioRef.current.removeEventListener('loadedmetadata', handlersRef.current.handleLoadedMetadata);
            audioRef.current.removeEventListener('timeupdate', handlersRef.current.handleTimeUpdate);
            audioRef.current.removeEventListener('ended', handlersRef.current.handleEnded);
            audioRef.current.removeEventListener('error', handlersRef.current.handleError);
            audioRef.current.pause();
            audioRef.current = null;
            handlersRef.current = {};
          }
        };
      }
    }, [mp3URL]);

    const togglePlay = async () => {
      if (!audioRef.current || !mp3URL) {
        return;
      }
      
      if (!playing) {
        try {
          await audioRef.current.play();
          setPlaying(true);
        } catch (error) {
          console.error('Error playing audio:', error);
          setPlaying(false);
        }
      } else {
        audioRef.current.pause();
        setPlaying(false);
      }
    };

    const formatTime = (seconds) => {
      if (isNaN(seconds)) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4">
          {/* Platform Warning for Web */}
          {!Capacitor.isNativePlatform() && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-yellow-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <span className="text-yellow-800 font-medium">Web Platform</span>
              </div>
              <p className="text-yellow-700 text-sm mt-1">
                Stethoscope device recording not available on web platform. Use the mobile app for recording.
              </p>
            </div>
          )}

          <div className="bg-white rounded-lg shadow-md p-6 mb-4">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Stethoscope</h1>
            <div className="flex gap-4 mb-4">
              <button 
                onClick={previousBtn}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Previous Recordings
              </button>
              <button 
                onClick={newRecordingBtn}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                New Recording
              </button>
            </div>
            {!newFlag && <PreviousList mp3FileList={mp3FileList} onItemClick={handleClick} mp3URL={mp3URL} imageURL={imageURL} playing={playing} onTogglePlay={togglePlay} currentTime={currentTime} duration={duration} formatTime={formatTime} onSubmitForReview={handleSubmitForReview} submitMessage={submitMessage} selectedFileName={selectedFileName} reportStr={reportStr} />}
            {newFlag && <NewRecording />}
            {Capacitor.isNativePlatform() && StethoPlugin && (
              <p className="mt-4 text-gray-600">{bpstatus}</p>
            )}
          </div>
          <BottomTab />
        </div>
      );
    };

const PreviousList=({mp3FileList, onItemClick, mp3URL, imageURL, playing, onTogglePlay, currentTime, duration, formatTime, onSubmitForReview, submitMessage, selectedFileName, reportStr}) =>{
    const progressPercentage = duration > 0 ? (currentTime / duration) * 100 : 0;
    
    return (
        <div className="mt-4">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Previous Recordings</h2>
          
          <div className="mb-4">
            <button 
              onClick={onSubmitForReview}
              disabled={!selectedFileName}
              className={`px-4 py-2 rounded-lg transition-colors mb-2 ${
                selectedFileName 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'bg-gray-400 text-gray-200 cursor-not-allowed'
              }`}
            >
              Submit for Review
            </button>
            {submitMessage && (
              <p className={`text-sm ${submitMessage.includes('submitted') && !submitMessage.includes('not') ? 'text-green-600' : 'text-red-600'}`}>
                {submitMessage}
              </p>
            )}
          </div>
          
          {imageURL !== "" && (
            <div className="mb-4">
              <h3 className="text-lg font-medium text-gray-800 mb-2">Stetho Waveform:</h3>
              <img src={imageURL} alt="Stethoscope waveform" className="max-w-full h-auto border border-gray-300 rounded-lg" />
            </div>
          )}
          
          {reportStr && reportStr !== null && reportStr !== '' && (
            <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h3 className="text-lg font-medium text-gray-800 mb-2">Report:</h3>
              <p className="text-gray-700 whitespace-pre-wrap">{reportStr}</p>
            </div>
          )}
          
          {mp3URL !== "" && (
            <div className="mb-4 bg-gray-50 border border-gray-200 rounded-lg p-4">
              <h3 className="text-lg font-medium text-gray-800 mb-3">Play Stetho Audio:</h3>
              
              {/* Progress Bar */}
              <div className="mb-3">
                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                  <div 
                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
                <div className="flex justify-between text-sm text-gray-600">
                  <span>{formatTime(currentTime)}</span>
                  <span>{formatTime(duration)}</span>
                </div>
              </div>
              
              {/* Play/Pause Button */}
              <button 
                onClick={onTogglePlay}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                {playing ? 'Pause' : 'Play'}
              </button>
            </div>
          )}
          
          {mp3FileList.length === 0 ? (
            <p className="text-gray-500">No previous recordings found.</p>
          ) : (
            <ul className="space-y-2">
              {mp3FileList.map((item, index) => (
                <li 
                  key={index} 
                  onClick={() => onItemClick(item)}
                  className="bg-gray-50 border border-gray-200 rounded-lg p-3 cursor-pointer hover:bg-gray-100 transition-colors"
                >
                  <p className="text-gray-700">{item}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      );
};

const NewRecording=()=>{
    const isWeb = !Capacitor.isNativePlatform();
    const [recordingDuration, setRecordingDuration] = useState('10s');
    
    const handleRecordBP = () => {
      if (Capacitor.isNativePlatform() && StethoPlugin) {
        StethoPlugin.recordBP({ value: 'Record BP', duration: recordingDuration }).then(result => {
          // Calls startRecording() in StethoPlugin.java
          console.log('Recording started');
        }).catch(error => {
          console.error('Error starting recording:', error);
        });
      }
    };
    
    return(
    <div className="mt-4">
       <h2 className="text-xl font-semibold text-gray-900 mb-4">Start by clicking 'Connect Device'</h2>
       
       {/* Recording Duration Selection */}
       <div className="mb-4">
         <label className="block text-sm font-medium text-gray-700 mb-2">Recording Duration</label>
         <div className="flex gap-6">
           <label className="flex items-center cursor-pointer">
             <input
               type="radio"
               name="recordingDuration"
               value="10s"
               checked={recordingDuration === '10s'}
               onChange={(e) => setRecordingDuration(e.target.value)}
               className="w-4 h-4 text-blue-600 focus:ring-blue-500"
             />
             <span className="ml-2 text-gray-700">10s</span>
           </label>
           <label className="flex items-center cursor-pointer">
             <input
               type="radio"
               name="recordingDuration"
               value="1min"
               checked={recordingDuration === '1min'}
               onChange={(e) => setRecordingDuration(e.target.value)}
               className="w-4 h-4 text-blue-600 focus:ring-blue-500"
             />
             <span className="ml-2 text-gray-700">1min</span>
           </label>
         </div>
       </div>

       {isWeb ? (
         <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
           <p className="text-gray-600">Device connection is only available on mobile platforms.</p>
         </div>
       ) : (
         <div className="flex gap-4">
           <button 
             onClick={connectUSBDevice}
             className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
           >
             Connect Device
           </button>
           <button 
             onClick={handleRecordBP}
             className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
           >
             Record
           </button>
           <button 
             onClick={() => uploadBP(user_id)}
             className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
           >
             Upload
           </button>
         </div>
       )}
    </div>
    );
};

const connectUSBDevice=()=>{
    if (Capacitor.isNativePlatform() && StethoPlugin) {
      StethoPlugin.connectUSB({ value: 'Connect device' }).then(result => {
        // Calls setupUsbConnection() in StethoPlugin.java
        console.log('USB connection initiated');
      }).catch(error => {
        console.error('Error connecting USB device:', error);
      });
    }
};

const recordBP=()=>{
  if (Capacitor.isNativePlatform() && StethoPlugin) {
    StethoPlugin.recordBP({ value: 'Record BP' }).then(result => {
      // Calls startRecording() in StethoPlugin.java
      console.log('Recording started');
    }).catch(error => {
      console.error('Error starting recording:', error);
    });
  }
};

const uploadBP=(userid)=>{
  if (Capacitor.isNativePlatform() && StethoPlugin) {
    console.log('Uploading with user_id:', userid);
    StethoPlugin.uploadBP({ value: 'Upload BP', user_id: userid }).then(result => {
      // Calls getPresignedUrlAndUpload() in StethoPlugin.java
      console.log('Upload initiated');
    }).catch(error => {
      console.error('Error uploading:', error);
    });
  }
};



export default Stetho;
